import LoadablePattern from "../loadables/Pattern";

const patterns = [
  {
    id: 0,
    collectionId: 1,
    absorptionId: 3,
    title: "Composer",
    title_fr: "Composer",
    title_en: "Compose",
    title_es: "Componer",

    component: LoadablePattern("Compose"),
//    configs: [0, 45, 90, 135, 180]
    configs: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9], // 10 combinaisons de percage en nb de trous
    //    configs_ref: [8, 9, 1, 6, 2, 5, 3, 7, 4], //Correspondance référence PDF OBERSOUND métier Percage des 9 trous positionnés
    configs_ref: [3, 5, 7, 9, 6, 4, 8, 1, 2], //Correspondance référence PDF OBERSOUND métier Percage des 9 trous positionnés

    ref:"ACT/4COM"

  },
  {
    id: 1,
    collectionId: 0,
    absorptionId: 2,
    title: "Petits oblongs",
    title_fr: "Petits oblongs",
    title_en: "Small slots",
    title_es: "Oblongos pequeños",

    component: LoadablePattern("SmallOblong"),
    configs: [
      {
        diameter: 6,
        spacing: [20],
        length: 40,
        pitch: 24
      },
      {
        diameter: 8,
        spacing: [20],
        length: 40,
        pitch: 24
      },
      {
        diameter: 10,
        spacing: [20],
        length: 40,
        pitch: 24
      }
    ],
    configs_ref: ["6E20P24", "8E20P24", "10E20P24"],
    ref: "O40X",
  },
  {
    id: 2,
    collectionId: 0,
    absorptionId: 2,
    title: "Grands oblongs",
    title_fr: "Grands oblongs",
    title_en: "Large slots",
    title_es: "Oblongos grandes",

    component: LoadablePattern("LargeOblong"),
    configs: [
      {
        diameter: 6,
        spacing: [32, 64],
        length: 98,
        pitch: 52
      },
      {
        diameter: 8,
        spacing: [32, 64],
        length: 98,
        pitch: 52
      },
      {
        diameter: 10,
        spacing: [32, 64],
        length: 98,
        pitch: 52
      }
    ],
    configs_ref: [
      {
        diameter_ref:"6",
        spacing_ref:["E32P52","E64P52"]
      },
      {
        diameter_ref:"8",
        spacing_ref:["E32P52","E64P52"]
      },
      {
        diameter_ref:"10",
        spacing_ref:["E32P52","E64P52"]
      }
    ],
    ref: "O98X",
  },
  {
    id: 3, // refaire la transparence en gris clair => que Entraxe
    title: "Rainurés / perforés",
    title_fr: "Rainurés / perforés",   //perforés
    title_en: "Grooved / perforated",  //perforated
    title_es: "Ranurados / perforados",

    collectionId: 0,
    absorptionId: 3,
    component: LoadablePattern("Groove"),
    configs: [0, 1, 2],
    configs_ref: ["20","32/16", "40/20"],
    ref:"R4E"

    /*
    Original before flim
    configs: [
      {
        diameter: 4,
        spacing: [20, 32, 40],
        length: 12,
        pitch: 4
      }
    ]}
    */
  },
  {
    id: 4, // pas de diametre ni de spacing et donc pas de popin entraxe ni diametre
    title: "Micro-perforés",
    title_fr: "Micro-perforés",
    title_en: "Micro-perforated",
    title_es: "Microperforados",

    ref:"05T2W095",
    component: LoadablePattern("Microdot"),
    collectionId: 0,
    absorptionId: 3,
    configs: [
      {
        diameter: 4,
        spacing: [20]
      }
    ]
  },
  {
    id: 5,
    title: "Ronds",
    title_fr: "Ronds",
    title_en: "Round",
    title_es: "Redondos",

    component: LoadablePattern("Dot"),
    collectionId: 0,
    absorptionId: 3,
    configs: [
      //        spacing: [16, 20, 32]
      //        1 mm = 3.779528 px; 1 px = 0.264583 mm
      {
        diameter: 7,            //  diameter: 3,
        spacing: [32, 40, 65]   //  spacing: [16, 20, 32]
      },
      {
        diameter: 12,          //  diameter: 6,
        spacing: [32, 40, 65]  //  spacing: [16, 20, 32]
      },
      {
        diameter: 16,         //  diameter: 8,
        spacing: [32, 40, 65]  //  spacing: [16, 20, 32]
      },
      {
        diameter: 19,         //  diameter: 10,
        spacing: [40, 65]  //  spacing: [16, 20, 32]
      },
    ],
    configs_ref: [
      {
        diameter_ref:"3",
        spacing_ref:["E16","E20","E32"]
      },
      {
        diameter_ref:"6",
        spacing_ref:["E16","E20","E32"]
      },
      {
        diameter_ref:"8",
        spacing_ref:["E16","E20","E32"]
      },
      {
        diameter_ref:"10",
        spacing_ref:["E20","E32"]
      },
    ],
    ref:"P"
  },
  {
    id: 6,
    collectionId: 1,
    absorptionId: 3,
    title: "Etirer",
    title_fr: "Etirer",
    title_en: "Strech",
    title_es: "Estirar",

    component: LoadablePattern("Stretch"),
    configs: [0, 45, 90, 135, 180],
    configs_ref: [5, 4, 3, 2, 1],
    ref:"ACT/4ETI"
  },
  {
    id: 7,
    collectionId: 1,
    absorptionId: 1,
    title: "Gommer",
    title_fr: "Gommer",
    title_en: "Erase",
    title_es: "Borrar",
    component: LoadablePattern("Erase"),
    configs: [0, 1, 2, 3, 4],
    configs_ref: [5, 4, 3, 2, 1],
    ref:"ACT/4GOM"
  },
  {
    id: 8,
    collectionId: 1,
    absorptionId: 3,
    title: "Graisser",
    title_fr: "Graisser",
    title_en: "Grease",
    title_es: "Niveles de Negrita",

    ref:"ACT/GRAI",
    component: LoadablePattern("Grease"),
    configs: [0, 3, 5, 7, 9],
    configs_ref: [0, 3, 5, 7, 9]
  },
  {
    id: 9,
    collectionId: 1,
    absorptionId: 2,
    title: "Secouer",
    title_fr: "Secouer",
    title_en: "Shake",
    title_es: "Sacudir",

    component: LoadablePattern("Shake"),
    configs: [0, 1, 2, 3, 4],
    configs_ref: [1, 2, 3, 4, 5],
    ref:"ACT/4SEC"
  },
  {
    id: 10,
    collectionId: 1,
    absorptionId: 2,
    title: "Souffler",
    title_fr: "Souffler",
    title_en: "Blow",
    title_es: "Soplar",

    component: LoadablePattern("Blow"),
    configs: [0, 45, 90, 135, 180, 225, 270, 315],
    configs_ref: [0, 45, 90, 135, 180, 225, 270, 315],
    ref:"ACT/4SOU"
  },
  {
    id: 11,
    collectionId: 2,
    subCollectionId: 1,
    absorptionId: 1,
    title: "Prairie",
    title_fr: "Prairie",
    title_en: "Meadow",
    title_es: "Pradera",

    ref:"5.5/PRA",
    component: LoadablePattern("Meadow")
  },
  {
    id: 12,
    collectionId: 2,
    subCollectionId: 1,
    absorptionId: 1,
    title: "Brindille",
    title_fr: "Brindille",
    title_en: "Twig",
    title_es: "Ramita",

    ref:"5.5/BRI",
    component: LoadablePattern("Twig")
  },
  {
    id: 13,
    collectionId: 2,
    subCollectionId: 1,
    absorptionId: 2,
    title: "Taillis",
    title_fr: "Taillis",
    title_en: "Copse",
    title_es: "Bosquecillo",

    ref:"5.5/TAI",
    component: LoadablePattern("Coppice")
  },
  {
    id: 14,
    collectionId: 2,
    subCollectionId: 1,
    absorptionId: 1,
    title: "Ecorce",
    title_fr: "Ecorce",
    title_en: "Bark",
    title_es: "Corteza",

    ref:"5.5/ECOR",
    component: LoadablePattern("Bark")
  },
  {
    id: 15,
    collectionId: 2,
    subCollectionId: 1,
    absorptionId: 1,
    title: "Liane",
    title_fr: "Liane",
    title_en: "Liana",
    title_es: "Liana",

    ref:"5.5/LIA",
    component: LoadablePattern("Liana")
  },
  {
    id: 16,
    collectionId: 2,
    subCollectionId: 2,
    absorptionId: 1,
    title: "Chair de poule",
    title_fr: "Chair de poule",
    title_en: "Gooseflesh",
    title_es: "Carne de gallina",

    ref:"5.5/CHA",
    component: LoadablePattern("Goosebumps")
  },
  {
    id: 17,
    collectionId: 2,
    subCollectionId: 2,
    absorptionId: 1,
    title: "Grain de beauté",
    title_fr: "Grain de beauté",
    title_en: "Beauty spot",
    title_es: "Lunar",

    ref:"5.5/GRA",
    component: LoadablePattern("Mole")
  },
  {
    id: 18,
    collectionId: 2,
    subCollectionId: 2,
    absorptionId: 2,
    title: "Ecaille",
    title_fr: "Ecaille",
    title_en: "Scale",
    title_es: "Escama",


    ref:"5.5/ECA",
    component: LoadablePattern("Scale")
  },
  {
    id: 19,
    collectionId: 2,
    subCollectionId: 2,
    absorptionId: 1,
    title: "Fourrure",
    title_fr: "Fourrure",
    title_en: "Fur",
    title_es: "Piel",

    ref:"5.5/FOU",
    component: LoadablePattern("Fur")
  },
  {
    id: 20,
    collectionId: 2,
    subCollectionId: 2,
    absorptionId: 2,
    title: "Ligne de vie",
    title_fr: "Ligne de vie",
    title_en: "Life line",
    title_es: "Línea de vida",

    ref:"5.5/LIG",
    component: LoadablePattern("Lifeline")
  },
  {
    id: 21,
    collectionId: 2,
    subCollectionId: 3,
    absorptionId: 1,
    title: "Canevas",
    title_fr: "Canevas",
    title_en: "Canvas",
    title_es: "Cañamazo",


    ref:"5.5/CAN",
    component: LoadablePattern("Canvas")
  },
  {
    id: 22,
    collectionId: 2,
    subCollectionId: 3,
    absorptionId: 1,
    title: "Patchwork",
    title_fr: "Patchwork",
    title_en: "Patchwork",
    title_es: "Patchwork",

    ref:"5.5/PAT",
    component: LoadablePattern("Patchwork")
  },
  {
    id: 23,
    collectionId: 2,
    subCollectionId: 3,
    absorptionId: 3,
    title: "Jersey",
    title_fr: "Jersey",
    title_en: "Jersey",
    title_es: "Jersey",

    ref:"5.5/JER",
    component: LoadablePattern("Jersey")
  },
  {
    id: 24,
    collectionId: 2,
    subCollectionId: 3,
    absorptionId: 1,
    title: "Capiton",
    title_fr: "Capiton",
    title_en: "Padding",
    title_es: "Borra de seda",

    ref:"5.5/CAP",
    component: LoadablePattern("Buffer")
  },
  {
    id: 25,
    collectionId: 2,
    subCollectionId: 3,
    absorptionId: 1,
    title: "Ecossais",
    title_fr: "Ecossais",
    title_en: "Scot",
    title_es: "Escosés",

    ref:"5.5/ECO",
    component: LoadablePattern("Tartan")
  },
  {
    id: 26,
    collectionId: 2,
    subCollectionId: 3,
    absorptionId: 1,
    title: "Brume",
    title_fr: "Brume",
    title_en: "Fog",
    title_es: "Bruma",

    ref:"5.5/BRU",
    component: LoadablePattern("Mist")
  },
  {
    id: 27,
    collectionId: 2,
    subCollectionId: 3,
    absorptionId: 2,
    title: "Pluie",
    title_fr: "Pluie",
    title_en: "Rain",
    title_es: "Lluvia",

    ref:"5.5/PLU",
    component: LoadablePattern("Rain")
  },
  {
    id: 28,
    collectionId: 2,
    subCollectionId: 3,
    absorptionId: 1,
    title: "Soleil",
    title_fr: "Soleil",
    title_en: "Sun",
    title_es: "Sol",

    ref:"5.5/SOL",
    component: LoadablePattern("Sun")
  },
  {
    id: 29,
    collectionId: 2,
    subCollectionId: 3,
    absorptionId: 1,
    title: "Vent",
    title_fr: "Vent",
    title_en: "Wind",
    title_es: "Biento",

    ref:"5.5/VEN",
    component: LoadablePattern("Wind")
  },
  {
    id: 30,
    collectionId: 2,
    subCollectionId: 3,
    absorptionId: 1,
    title: "Neige",
    title_fr: "Neige",
    title_en: "Snow",
    title_es: "Nieve",

    ref:"5.5/NEI",
    component: LoadablePattern("Snow")
  },
  {
    id: 31,
    collectionId: 2,
    subCollectionId: 3,
    absorptionId: 2,
    title: "Amplitude",
    title_fr: "Amplitude",
    title_en: "Amplitude",
    title_es: "Amplitud",

    ref:"5.5/AMP",
    component: LoadablePattern("Range")
  },
  {
    id: 32,
    collectionId: 2,
    subCollectionId: 3,
    absorptionId: 3,
    title: "Onde",
    title_fr: "Onde",
    title_en: "Wave",
    title_es: "Onda",

    ref:"5.5/OND",
    component: LoadablePattern("Wave")
  },
  {
    id: 33,
    collectionId: 2,
    subCollectionId: 3,
    absorptionId: 3,
    title: "Crépitement",
    title_fr: "Crépitement",
    title_en: "Crackling",
    title_es: "Crepitación",

    ref:"5.5/CRE",
    component: LoadablePattern("Crackling")
  },
  {
    id: 34,
    collectionId: 2,
    subCollectionId: 3,
    absorptionId: 1,
    title: "Cadence",
    title_fr: "Cadence",
    title_en: "Rhythm",
    title_es: "Compás",

    ref:"5.5/CAD",
    component: LoadablePattern("Rate")
  },
  {
    id: 35,
    collectionId: 2,
    subCollectionId: 3,
    absorptionId: 2,
    title: "Fréquence",
    title_fr: "Fréquence",
    title_en: "Frequency",
    title_es: "Frequencia",

    ref:"5.5/FRE",
    component: LoadablePattern("Frequence")
  }
];

export const patternsByCollectionIds = patterns.reduce((acc, p) => {
  acc[p.collectionId] = acc[p.collectionId] || [];
  acc[p.collectionId].push(p);
  return acc;
}, {});

export const patternsByIds = patterns.reduce((acc, p) => {
  acc[p.id] = p;
  return acc;
}, {});

export default patterns;



// WEBPACK FOOTER //
// ./src/constants/patterns.js